import { render } from "./LiteIntegrationAssetLocations.vue?vue&type=template&id=945f20cc"
import script from "./LiteIntegrationAssetLocations.vue?vue&type=script&lang=js"
export * from "./LiteIntegrationAssetLocations.vue?vue&type=script&lang=js"

import exportComponent from "/home/adssilicondigital/ads.silicon.digital/vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__